import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { JonumKycPromptView } from '@sorare/core/src/components/jonum/JonumVerificationDialog/JonumKycPromptView';
import { ANY_SPORT_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

const PageRoot = styled(Vertical).attrs({ gap: 0 })`
  min-height: var(--100vh);
`;

const JonumKycPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { isIosApp, postMessage } = useIsMobileApp();
  const navigate = useNavigate();

  const close = () => {
    if (isIosApp) {
      postMessage('closeCurrentWebview');
    } else {
      navigate(generateSportContextPath(ANY_SPORT_HOME));
    }
  };

  return (
    <PageRoot>
      <JonumKycPromptView onDone={close} />
    </PageRoot>
  );
};

export default JonumKycPage;
